import { render, staticRenderFns } from "./PracticesManagement.vue?vue&type=template&id=0eed5724&"
import script from "./PracticesManagement.vue?vue&type=script&lang=js&"
export * from "./PracticesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports